import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { reject } from "lodash";
import { mainAxios } from "../../app/api";
import service from "../../config.json";
import { errorToast } from "../../helpers/toaster";
const { Authorization } = JSON.parse(sessionStorage.getItem("userData")) || {};

const {
  getCities,
  hotelSearch,
  hotelSearchPrice,
  hotelDetails,
  hotelBook,
  selectRoom,
  getCountries,
  getCitywithCountry,
  getIntroHotel,
  getTopHotel,
} = service;
//

const initialState = {
  hotelCities: [],
  searchedHotels: [],
  hotelsPrice: [],
  singleHotelData: {},
  loading: true,
  priceLoading: true,
  noRooms: false,
  bookingStatus: "",
  hotelFilters: [],
  hotelPriceFilter: [],
  starsCount: {},
  preBooked: true,
  guestDetails: [],
  rejected: false,
  singleLoading: false,
  SelectRoom: {},
  singlePriceLoading: false,
  singleHotelPrice: [],
  selectRoomStatus: false,
  hotelByCity: [],
  topHotel: [],
};

export const fetchCitiesAsync = createAsyncThunk(
  "hotel/fetchCitiesAsync",

  async (state) => {
    const { city, Authorization } = state || {};

    try {
      const res = await mainAxios.get(getCities.concat(`/${city}`), {
        headers: { Authorization },
      });
      return res?.data;
    } catch (err) {
      //
    }
  }
);

// hotelSearchAsync
export const hotelSearchAsync = createAsyncThunk(
  "hotel/hotelSearchAsync",
  async (val) => {
    reject("Custom Reject");
    const { data, Authorization } = val || {};
    try {
      if (data?.city !== null && data?.city !== undefined) {
        const res = await mainAxios.post(
          hotelSearch,
          {
            cityCode: data.city,
            checkIn: data.checkIn,
            checkOut: data.checkOut,
            nationality: data.Nationality,
            PaxRooms: JSON.parse(data.guestDetails),
          },
          {
            headers: {
              Authorization,
            },
          }
        );

        return res.data;
      } else {
      }
    } catch (err) {
      return err?.response?.data;
    }
  }
);

export const fetchHotelSearchPrice = createAsyncThunk(
  "hotel/fetchHotelSearchPrice",
  async (val) => {
    const { data, Authorization } = val || {};
    try {
      const res = await mainAxios.post(
        hotelSearchPrice,
        {
          cityCode: data.city,
          checkIn: data.checkIn,
          checkOut: data.checkOut,
          PaxRooms: JSON.parse(data.guestDetails),
          nationality: data.Nationality,
        },
        {
          headers: { Authorization },
        }
      );
      return res.data;
    } catch (err) {
      return err?.response?.data;
    }
  }
);

// fetchSingleHotelData
export const fetchSingleHotelData = createAsyncThunk(
  "hotel/fetchSingleHotelData",
  async (val) => {
    const { guestDetails, state, Authorization } = val;
    try {
      const res = await mainAxios.post(
        hotelDetails,
        {
          cityCode: state.city,
          checkIn: state.checkIn,
          checkOut: state.checkOut,
          PaxRooms: guestDetails,
          hotelId: state.hotelId,
          nationality: state.Nationality,
        },
        {
          headers: {
            Authorization,
          },
        }
      );
      return res.data;
    } catch (err) {
      return err.response.data;
    }
  }
);

//Fetching signle hotel price
export const fetchSingleHotelDataPrice = createAsyncThunk(
  "hotel/fetchSingleHotelDataPrice",
  async (val) => {
    const { guestDetails, state, Authorization } = val;
    try {
      const res = await mainAxios.post(
        hotelSearchPrice,
        {
          cityCode: state.city,
          checkIn: state.checkIn,
          checkOut: state.checkOut,
          PaxRooms: guestDetails,
          hotelId: state.hotelId,
          nationality: state.Nationality,
        },
        {
          headers: {
            Authorization,
          },
        }
      );

      return res.data;
    } catch (err) {
      return err.response.data;
    }
  }
);

// state, customers
export const hotelBookAsync = createAsyncThunk(
  "hotel/hotelBookAsync",
  async (val, { rejectWithValue }) => {
    const { Authorization, Obj, selectedRoom, checkIn, checkOut } = val;

    const { state, customers } = Obj;

    const { BookingCode, TotalFare, hotelId, CountryCode, MobileNo, Email } =
      state;

    const PhoneNumber = CountryCode.concat(MobileNo);

    let arr = [];

    customers.forEach((ele) => {
      arr.push({
        CustomerNames: ele,
      });
    });

    try {
      const res = await mainAxios.post(
        hotelBook,
        {
          BookingCode,
          CustomerDetails: arr,
          TotalFare,
          EmailId: Email,
          PhoneNumber,
          hotelId,
          selectedRoom: selectedRoom,
          CheckIn: checkIn,
          CheckOut: checkOut,
        },
        {
          headers: {
            Authorization,
          },
        }
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response);
      // return err.response;
    }
  }
);

export const getCountriesAsync = createAsyncThunk(
  "hotel/getCountriesAsync",
  async () => {
    try {
      const res = await mainAxios.get(getCountries, {
        headers: {
          Authorization,
        },
      });
      return res.data;
    } catch (err) {
      return err.response.data;
    }
  }
);

// hotel/getCitywithCountry
export const fetchCitywithCountry = createAsyncThunk(
  "hotel/fetchCitywithCountry",
  async (data) => {
    const { name, Authorization } = data || {};
    try {
      const res = await mainAxios.get(getCitywithCountry.concat(`/${name}`), {
        headers: {
          Authorization,
        },
      });
      return res.data;
    } catch (err) {
      return err.response.data;
    }
  }
);

// selectHotelRoomAsync
export const selectHotelRoomAsync = createAsyncThunk(
  "hotel/selectHotelRoomAsync",
  async (state) => {
    const { code, Authorization } = state;

    try {
      const res = await mainAxios.post(
        selectRoom,
        {
          BookingCode: code,
        },
        {
          headers: {
            Authorization,
          },
        }
      );
      return res.data;
    } catch (err) {
      return err.response.data;
    }
  }
);

export const GetHotelByCityAsync = createAsyncThunk(
  "hotel/GetHotelByCityAsync",
  async () => {
    try {
      const res = await mainAxios.get(
        getIntroHotel,
        {},
        {
          headers: {
            Authorization,
          },
        }
      );

      return res.data;
    } catch (err) {
      return err.response.data;
    }
  }
);

export const GetTopHotelAsync = createAsyncThunk(
  "hotel/GetTopHotelAsync",
  async () => {
    try {
      const res = await mainAxios.get(
        getTopHotel,
        {},
        {
          headers: {
            Authorization,
          },
        }
      );
      return res.data;
    } catch (err) {
      return err.response.data;
    }
  }
);

export const hotelSlice = createSlice({
  name: "hotel",
  initialState,
  reducers: {
    adultInc: (state) => {
      state.adultsCount = state.adultsCount + 1;
    },
    roomInc: (state) => {
      state.roomsCount = state.roomsCount + 1;
    },
    childInc: (state) => {
      state.childsCount = state.childsCount + 1;
    },
    adultDec: (state) => {
      state.adultsCount = state.adultsCount - 1;
    },
    roomDec: (state) => {
      state.roomsCount = state.roomsCount - 1;
    },
    childDec: (state) => {
      state.childsCount = state.childsCount - 1;
    },
    resetBooked: (state) => {
      state.bookingStatus = "";
    },
    resetCounts: (state) => {
      state.adultsCount = 1;
      state.childsCount = 0;
      state.roomsCount = 1;
    },
    setCounts: (state, { payload }) => {
      state.guestDetails = payload;
    },
    resetPriceLoading: (state) => {
      state.priceLoading = false;
      // state.noRooms = true;
    },
    setPriceLoading: (state, { payload }) => {
      state.priceLoading = payload;
    },
    setHotelFilters: (state, { payload }) => {
      state.hotelFilters = payload;
    },
    setHotelPriceFilter: (state, { payload }) => {
      state.hotelPriceFilter = payload;
    },
    removeHotelFilter: (state, { payload }) => {
      if (payload === "all") {
        state.hotelFilters = [];
      } else {
        state.hotelFilters = state.hotelFilters.filter(
          (ele) => ele !== payload
        );
      }
    },
    removeHotelPriceFilter: (state, { payload }) => {
      if (payload === "all") {
        state.hotelPriceFilter = [];
      } else {
        state.hotelPriceFilter = state.hotelPriceFilter.filter(
          (ele) => ele !== payload
        );
      }
    },
    setGuestsDetails: (state, { payload }) => {
      state.hotel.guestDetails = payload;
    },
    resetRejected: (state) => {
      state.rejected = false;
    },
    clearFilterHandler: (state, { payload }) => {
      state.hotelPriceFilter = [];
      state.hotelFilters = [];

      state.clearFilter = payload;
    },
  },
  extraReducers: {
    [fetchCitiesAsync.fulfilled]: (state, { payload }) => {
      return { ...state, hotelCities: payload.data, loading: false };
    },
    [hotelSearchAsync.pending]: (state) => {
      return { ...state, loading: true };
    },
    [hotelSearchAsync.fulfilled]: (state, { payload }) => {
      if (payload?.success) {
        let starsCount = payload.data[payload.data.length - 1];
        payload.data.splice([payload.data.length - 1], 1);
        return {
          ...state,
          searchedHotels: payload?.data,
          starsCount: starsCount,
          loading: false,
          preBooked: true,
        };
      } else {
        // errorToast(payload.message);
        return { ...state, loading: false };
      }
    },
    [hotelSearchAsync.rejected]: (state, payload) => {
      errorToast("Something Went Wrong!");
      return { ...state, loading: false, rejected: true };
    },
    [fetchHotelSearchPrice.pending]: (state) => {
      return {
        ...state,
        priceLoading: true,
        hotelsPrice: [],
        noRooms: true,
      };
    },
    [fetchHotelSearchPrice.fulfilled]: (state, { payload }) => {
      if (payload?.success === true) {
        return {
          ...state,
          priceLoading: false,
          hotelsPrice: payload.data,
          noRooms: false,
        };
      }
      if (payload?.success === false) {
        errorToast("No rooms Available");
        return {
          ...state,
          noRooms: true,
          priceLoading: false,
          hotelsPrice: [],
          loading: false,
        };
      }
    },
    [fetchHotelSearchPrice.rejected]: (state) => {
      errorToast("Something Went Wrong!");
      return { ...state, rejected: true };
    },
    [fetchSingleHotelData.pending]: (state) => {
      return { ...state, loading: true, singleLoading: true };
    },
    [fetchSingleHotelData.fulfilled]: (state, { payload }) => {
      if (payload?.success) {
        return {
          ...state,
          loading: false,
          singleHotelData: payload.data,
          singleLoading: false,
        };
      } else {
        errorToast(payload.message);
        return { ...state, loading: false, singleLoading: false };
      }
    },
    [fetchSingleHotelData.rejected]: (state) => {
      errorToast("Something Went Wrong!");
      return { ...state, loading: false, rejected: true };
    },
    [fetchSingleHotelDataPrice.pending]: (state) => {
      return { ...state, singlePriceLoading: true };
    },
    [fetchSingleHotelDataPrice.fulfilled]: (state, { payload }) => {
      if (payload?.success) {
        return {
          ...state,
          singleHotelPrice: payload,
          singlePriceLoading: false,
        };
      } else {
        errorToast(payload.message);
        return { ...state, singlePriceLoading: false };
      }
    },
    [fetchSingleHotelDataPrice.rejected]: (state) => {
      errorToast("Something Went Wrong!");
      return { ...state, singlePriceLoading: false };
    },
    [hotelBookAsync.pending]: (state) => {
      return { ...state, loading: true, bookingStatus: "" };
    },
    [hotelBookAsync.fulfilled]: (state, { payload }) => {
      if (payload?.success) {
        return {
          ...state,
          loading: false,
          bookingStatus: payload.data,
          message: payload.data.message,
          status: 200,
        };
        // return { ...state, loading: false, bookingStatus: "Booked" };
      } else {
        if (parseInt(payload.status) === 300) {
          return {
            ...state,
            loading: false,
            bookingStatus: false,
            message: payload.data.message,
            status: payload.status,
          };
        } else {
          return {
            ...state,
            loading: false,
            bookingStatus: false,
            message: payload.data.message,
            status: payload.status,
          };
        }
      }
    },
    [hotelBookAsync.rejected]: (state, payload) => {
      errorToast("Something Went Wrong!");
      console.log({ payload }, "hotel");
      return { ...state, loading: false, rejected: true };
    },
    [selectHotelRoomAsync.pending]: (state) => {
      return { ...state, loading: false, selectRoomStatus: false };
    },
    [selectHotelRoomAsync.fulfilled]: (state, { payload }) => {
      if (payload?.success) {
        return {
          ...state,
          loading: false,
          preBooked: true,
          SelectRoom: payload,
          selectRoomStatus: true,
        };
      } else {
        return {
          ...state,
          loading: false,
          preBooked: false,
          SelectRoom: payload,
          selectRoomStatus: true,
        };
      }
      // return { ...state, loading: false };
    },
    [selectHotelRoomAsync.rejected]: (state) => {
      errorToast("Something Went Wrong!");
      return {
        ...state,
        loading: false,
        rejected: true,
        selectRoomStatus: false,
      };
    },
    [getCountriesAsync.pending]: (state) => {
      return { ...state };
    },
    [getCountriesAsync.fulfilled]: (state, { payload }) => {
      return { ...state, countryList: payload.data };
    },
    [getCountriesAsync.rejected]: (state) => {
      errorToast("Something Went Wrong!");
      return { ...state, loading: false, rejected: true };
    },
    [fetchCitywithCountry.fulfilled]: (state, { payload }) => {
      return { ...state, cityNames: payload?.data };
    },

    [GetHotelByCityAsync.pending]: (state) => {
      return { ...state, loading: true };
    },
    [GetHotelByCityAsync.fulfilled]: (state, { payload }) => {
      return { ...state, hotelByCity: payload.data, loading: false };
    },

    [GetTopHotelAsync.pending]: (state) => {
      return { ...state, loading: true };
    },
    [GetTopHotelAsync.fulfilled]: (state, { payload }) => {
      return { ...state, topHotel: payload.data, loading: false };
    },
  },
});

export const getHotelRejected = (state) => {
  return state.hotel.rejected;
};

export const getLoading = (state) => {
  return state.hotel.loading;
};

export const getNoRooms = (state) => {
  return state.hotel.noRooms;
};

export const getHotelCities = (state) => {
  return state.hotel.hotelCities;
};

export const getCounts = (state) => {
  const { adultsCount, roomsCount, childsCount, childAge } = state.hotel;
  return { adultsCount, roomsCount, childsCount, childAge };
};

export const getHotelSearched = (state) => {
  return state.hotel.searchedHotels;
};

export const getPriceLoading = (state) => {
  return state.hotel.priceLoading;
};

export const getSingleHotelData = (state) => {
  return state.hotel.singleHotelData;
};

export const getsingleHotelPrice = (state) => {
  return state.hotel.singleHotelPrice;
};
export const getSinglePriceLoading = (state) => {
  return state.hotel.singlePriceLoading;
};

export const getRoomBooked = (state) => {
  return state.hotel.bookingStatus;
};

export const getHotelFilters = (state) => {
  return state.hotel.hotelFilters;
};

export const getHotelPriceFilters = (state) => {
  return state.hotel.hotelPriceFilter;
};

export const getClearFilters = (state) => {
  return state.hotel.clearFilter;
};

export const getCountryList = (state) => {
  return state.hotel.countryList;
};

export const getStarsCount = (state) => {
  return state.hotel.starsCount;
};

export const getGuestDetails = (state) => {
  return state.hotel.guestDetails;
};

export const getPreBook = (state) => {
  return state.hotel.preBooked;
};

export const getHotelByCity = (state) => {
  return state.hotel.hotelByCity;
};

export const getTopHotels = (state) => {
  return state.hotel.topHotel;
};

// Action creators are generated for each case reducer function
export const {
  adultInc,
  roomInc,
  childInc,
  adultDec,
  roomDec,
  childDec,
  setCounts,
  setHotelFilters,
  resetBooked,
  resetCounts,
  removeHotelFilter,
  removeHotelPriceFilter,
  resetPriceLoading,
  clearFilterHandler,
  setPriceLoading,
  setHotelPriceFilter,
  resetRejected,
} = hotelSlice.actions;

export default hotelSlice.reducer;
